// src/hooks/useToast.js
import { useCallback } from 'react';

export const useToast = () => {
  const showToast = useCallback((message, statusCode) => {
    // If ToastManager is ready, show immediately
    if (window.showToast && typeof window.showToast === 'function') {
      window.showToast(message, statusCode);
      return;
    }
    // Otherwise push to queue to be flushed when ToastManager mounts
    window._toastQueue = window._toastQueue || [];
    window._toastQueue.push({ message, statusCode });
  }, []);

  return { showToast };
};

export default useToast;